import React, { useState, useEffect } from "react";
import Calendar from "react-calendar"; // Import the calendar component
import "react-calendar/dist/Calendar.css"; // Calendar styles
import "./Accomodation.css";
import host from "../config";
const Accommodation = () => {
  const [locations] = useState([
    { id: 1, name: "Gurajada Kalakshetram" },
    { id: 2, name: "MGM LAN" },
    { id: 3, name: "Chinnamusidivada" },
    { id: 4, name: "Children's Arena" },
  ]); // Predefined location list
  const [selectedLocation, setSelectedLocation] = useState(""); // Selected location ID
  const [roomsData, setRoomsData] = useState([]); // Room options
  const [selectedRoom, setSelectedRoom] = useState(""); // Selected room
  const [selectedDate, setSelectedDate] = useState(new Date()); // Selected date from calendar
  const [availabilityData, setAvailabilityData] = useState({}); // Available room data for each day
  const [roomPurpose, setRoomPurpose] = useState(""); // Purpose of the selected room
  // const host = "https://api.vmrdarental.com";
  // let host = "http://13.203.181.236:3000";
  // let host = "https://api.vmrdarental.com";
  // Fetch rooms based on selected location
  const handleLocationChange = async (event) => {
    const locationId = event.target.value;
    setSelectedLocation(locationId);

    // Clear previous room selection and data
    setRoomsData([]);
    setSelectedRoom("");
    setRoomPurpose("");

    try {
      const response = await fetch(`${host}/get-rooms?location=${locationId}`);
      const data = await response.json();

      // Remove duplicate room IDs
      const uniqueRooms = data.reduce((acc, room) => {
        if (!acc.some((r) => r.room_id === room.room_id)) {
          acc.push(room);
        }
        return acc;
      }, []);

      setRoomsData(uniqueRooms);
    } catch (error) {
      console.error("Error fetching rooms:", error);
    }
  };

  // Fetch availability data when location, room, and date are selected
  const fetchRoomAvailability = async (locationId, selectedDate, roomId) => {
    // Ensure selectedDate is a Date object, if it's an array (in case of range selection)
    const dateToUse = Array.isArray(selectedDate)
      ? selectedDate[0]
      : selectedDate;

    // Check if it's a valid Date object
    if (!(dateToUse instanceof Date)) {
      console.error("Invalid date selected:", dateToUse);
      return;
    }

    const formattedDate = dateToUse.toISOString().split("T")[0]; // Format date as YYYY-MM-DD

    try {
      const response = await fetch(
        `${host}/get-room-availability?location=${locationId}&date=${formattedDate}&roomId=${roomId}`
      );
      const data = await response.json();
      setAvailabilityData(data);
    } catch (error) {
      console.error("Error fetching availability:", error);
    }
  };

  useEffect(() => {
    if (selectedLocation && selectedRoom && selectedDate) {
      fetchRoomAvailability(selectedLocation, selectedDate, selectedRoom);
    }
  }, [selectedLocation, selectedRoom, selectedDate]);

  // Render the calendar tile content to show available rooms
  const renderDayTile = ({ date, view }) => {
    const dateString = date.toISOString().split("T")[0]; // Format date as YYYY-MM-DD
    if (availabilityData[dateString]) {
      return (
        <div className="room-availability">
          {/* Example availability display */}
          {availabilityData[dateString].isAvailable
            ? "Available"
            : "Not Available"}
        </div>
      );
    }
    return null;
  };

  // Display the purpose of the room when selected
  const handleRoomSelection = (roomId) => {
    setSelectedRoom(roomId);
    const room = roomsData.find((room) => room.room_id === roomId);
    if (room) {
      setRoomPurpose(room.purpose); // Assuming 'purpose' is part of the room data
    }
  };

  return (
    <div>
      <h1>Accommodation Booking</h1>

      {/* Single Row for Location and Room Dropdowns */}
      <div className="single-row">
        {/* Location Dropdown */}
        <div className="dropdown-container">
          <label>
            <b>Select Location:</b>
          </label>
          <select value={selectedLocation} onChange={handleLocationChange}>
            <option value="" disabled>
              -- Select Location --
            </option>
            {locations.map((location) => (
              <option key={location.id} value={location.id}>
                {location.name}
              </option>
            ))}
          </select>
        </div>

        {/* Rooms Dropdown */}
        {roomsData.length > 0 && (
          <div className="dropdown-container">
            <label>
              <b>Select Room:</b>
            </label>
            <select
              value={selectedRoom}
              onChange={(e) => handleRoomSelection(e.target.value)}
            >
              <option value="" disabled>
                -- Select Room --
              </option>
              {roomsData.map((room) => (
                <option key={room.room_id} value={room.room_id}>
                  {room.room_name} (Rs. {room.amount} per day)
                </option>
              ))}
            </select>
          </div>
        )}
      </div>

      {/* Room Purpose Display */}
      {roomPurpose && (
        <div className="room-purpose">
          <p>
            <b>Room Purpose:</b> {roomPurpose}
          </p>
        </div>
      )}

      {/* Calendar Below Dropdowns */}
      <div className="calendar-container">
        <Calendar
          selectRange
          value={selectedDate}
          onChange={(date) => setSelectedDate(date)} // Make sure to handle the array or single date here
          minDate={new Date()}
          tileContent={renderDayTile}
          showDoubleView
        />
      </div>
    </div>
  );
};

export default Accommodation;
